/* eslint-disable camelcase */
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type {
  IdentityProviderDto,
  DisableSsoDto,
  EnableSsoDto,
  OrganizationIdpMutationRequestDto,
} from './dto';
import type { DisableSsoRequestModel, EnableSsoRequestModel } from './model';

export const IDENTITY_PROVIDERS_QUERY_KEY = 'identityProviders';

export async function fetchIdentityProviders(accountId: number): Promise<IdentityProviderDto[]> {
  const { data: identityProviders } = await axios.get<IdentityProviderDto[]>(
    `/api/v1/accounts/${accountId}/identity-providers`,
  );

  return identityProviders;
}

export async function enableSsoOnOrganization({
  accountId,
  organizationId,
  identityProviderLoginId,
}: EnableSsoRequestModel): Promise<AxiosResponse<EnableSsoDto>> {
  const path = `/api/v1/accounts/${accountId}/organizations/${organizationId}/identity-provider`;
  const payload: OrganizationIdpMutationRequestDto = {
    identity_provider_login_id: identityProviderLoginId,
  };
  return axios.put<EnableSsoDto>(path, payload);
}

export function disableSsoOnOrganization({
  accountId,
  organizationId,
  identityProviderLoginId = null,
}: DisableSsoRequestModel): Promise<AxiosResponse<DisableSsoDto>> {
  const path = `/api/v1/accounts/${accountId}/organizations/${organizationId}/identity-provider`;
  const payload: OrganizationIdpMutationRequestDto = {
    identity_provider_login_id: identityProviderLoginId,
  };
  return axios.put<DisableSsoDto>(path, payload);
}
